import { useState, useEffect } from 'react';

export function usePrivileges() {
    const [user, setUser] = useState(null);

    useEffect(() => {
        const loadUser = () => {
            const userStr = sessionStorage.getItem('user');
            if (userStr) {
                try {
                    setUser(JSON.parse(userStr));
                } catch (e) {
                    console.error("Error parsing user from sessionStorage", e);
                }
            }
        };

        loadUser();

        window.addEventListener('privilegesUpdated', loadUser);
        return () => window.removeEventListener('privilegesUpdated', loadUser);
    }, []);

    const role = user?.role || '';
    const privileges = user?.privileges || [];
    
    // SUPERADMIN siempre tiene todos los privilegios a nivel de frontend
    const hasPrivilege = (priv) => role === 'SUPERADMIN' || privileges.includes(priv);

    const isCiudadano = role === 'CIUDADANO';
    const isFuncionario = role === 'FUNCIONARIO';

    return {
        user,
        role,
        privileges,
        hasPrivilege,
        isCiudadano,
        isFuncionario
    };
}
